import { Action } from '@/lib/frontend/store/actions';
import sessionReducer, { Session } from '@/lib/frontend/store/reducers/session';
import { ReducerInputState } from '@/types/store';
import accountsByIDReducer, { AccountsByID } from '@/lib/frontend/store/reducers/accountsByID';
import usersByIDReducer, { UsersByID } from '@/lib/frontend/store/reducers/usersByID';
import currentUserReducer, { CurrentUser } from '@/lib/frontend/store/reducers/currentUser';
import shopReducer, { Shop } from '@/lib/frontend/store/reducers/shop';
import pagesReducer, { Pages } from '@/lib/frontend/store/reducers/pages';
import searchReducer, { SearchState } from '@/lib/frontend/store/reducers/search';
import licensesBySerialReducer, {
  LicensesBySerial,
} from '@/lib/frontend/store/reducers/licensesBySerial';
import recaptchaReducer, { Recaptcha } from './recaptcha';
import storeCreditChangesByAccountIDReducer, {
  StoreCreditChangesByAccountID,
} from './storeCreditChangesByAccountID';
import ordersByIDReducer, { OrdersByID } from './ordersByID';
import modalReducer, { Modal } from './modal';
import licenseTradeInValueBySerialReducer, {
  LicenseTradeInValueBySerial,
} from './licenseTradeInValueBySerial';
import notificationsReducer, { Notifications } from './notifications';
import ordersByNumberReducer, { OrdersByNumber } from './ordersByNumber';
import invoicesByNumberReducer, { InvoicesByNumber } from './invoicesByNumber';

export type AppState = {
  session: Session;
  modal: Modal;
  pages: Pages;
  shop: Shop;
  currentUser: CurrentUser;
  licensesBySerial: LicensesBySerial;
  // licensesByID: LicensesByID;
  ordersByNumber: OrdersByNumber;
  ordersByID: OrdersByID;
  invoicesByNumber: InvoicesByNumber;
  licenseTradeInValueBySerial: LicenseTradeInValueBySerial;
  storeCreditChangesByAccountID: StoreCreditChangesByAccountID;
  // rentalConversionsByID: RentalConversionsByID;
  usersByID: UsersByID;
  accountsByID: AccountsByID;
  notifications: Notifications;
  recaptcha: Recaptcha;
  search: SearchState;
};

const defaultState = {
  session: undefined,
  modal: undefined,
  pages: undefined,
  currentUser: undefined,
  licensesBySerial: undefined,
  // licensesByID: undefined,
  ordersByNumber: undefined,
  ordersByID: undefined,
  invoicesByNumber: undefined,
  licenseTradeInValueBySerial: undefined,
  storeCreditChangesByAccountID: undefined,
  // rentalConversionsByID: undefined,
  usersByID: undefined,
  accountsByID: undefined,
  notifications: undefined,
  recaptcha: undefined,
  search: undefined,
};

export default function reducers(
  state: ReducerInputState<AppState> = defaultState,
  action: Action,
): AppState {
  return {
    session: sessionReducer(state.session, action),
    pages: pagesReducer(state.pages, action),
    modal: modalReducer(state.modal, action),
    shop: shopReducer(state.shop, action),
    currentUser: currentUserReducer(state.currentUser, action),
    licensesBySerial: licensesBySerialReducer(state.licensesBySerial, action),
    // licensesByID: licensesByIDReducer(state.licensesByID, action),
    ordersByNumber: ordersByNumberReducer(state.ordersByNumber, action),
    ordersByID: ordersByIDReducer(state.ordersByID, action),
    invoicesByNumber: invoicesByNumberReducer(state.invoicesByNumber, action),
    licenseTradeInValueBySerial: licenseTradeInValueBySerialReducer(
      state.licenseTradeInValueBySerial,
      action,
    ),
    storeCreditChangesByAccountID: storeCreditChangesByAccountIDReducer(
      state.storeCreditChangesByAccountID,
      action,
    ),
    // rentalConversionsByID: rentalConversionsByIDReducer(
    //   state.rentalConversionsByID,
    //   action,
    // ),
    usersByID: usersByIDReducer(state.usersByID, action),
    accountsByID: accountsByIDReducer(state.accountsByID, action),
    notifications: notificationsReducer(state.notifications, action),
    recaptcha: recaptchaReducer(state.recaptcha, action),
    search: searchReducer(state.search, action),
  };
}
